import { Component, input } from '@angular/core';

export type AlertTone = 'danger' | 'warn' | 'success' | 'info';

const ICON_BY_TONE: Readonly<Record<AlertTone, string>> = {
    danger: 'pi pi-exclamation-triangle',
    warn: 'pi pi-exclamation-circle',
    success: 'pi pi-check-circle',
    info: 'pi pi-info-circle'
};

/**
 * Inline message. Eight screens used to hand-roll a red Tailwind box each, none
 * of which followed the theme or had a dark variant.
 */
@Component({
    selector: 'app-alert',
    template: `
        <div class="alert" [attr.data-tone]="tone()" [attr.role]="tone() === 'danger' ? 'alert' : 'status'">
            <i class="alert__icon" [class]="icon" aria-hidden="true"></i>
            <div class="alert__content">
                <ng-content />
            </div>
        </div>
    `,
    styles: `
        .alert {
            display: flex;
            align-items: flex-start;
            gap: 0.625rem;
            padding: 0.75rem 0.875rem;
            border: 1px solid color-mix(in srgb, var(--alert-color) 35%, transparent);
            border-radius: 0.5rem;
            background: var(--alert-surface);
            color: var(--alert-color);
            font-size: 0.8125rem;
            line-height: 1.5;
        }

        .alert__icon {
            font-size: 1rem;
            line-height: 1.2;
        }

        .alert__content {
            color: var(--p-text-color);
        }

        .alert[data-tone='danger'] {
            --alert-color: var(--app-state-danger-color);
            --alert-surface: var(--app-state-danger-surface);
        }

        .alert[data-tone='warn'] {
            --alert-color: var(--app-state-warn-color);
            --alert-surface: var(--app-state-warn-surface);
        }

        .alert[data-tone='success'] {
            --alert-color: var(--app-state-success-color);
            --alert-surface: var(--app-state-success-surface);
        }

        .alert[data-tone='info'] {
            --alert-color: var(--app-state-info-color);
            --alert-surface: var(--app-state-info-surface);
        }
    `
})
export class AlertComponent {
    readonly tone = input<AlertTone>('danger');

    protected get icon(): string {
        return ICON_BY_TONE[this.tone()];
    }
}
